import React from 'react';
import LikedYourSpaceComponent from '../../components/likedYourSpace';


interface LikedYourSpaceContainerInterface {

}

const LikedYourSpaceContainer: React.FC<LikedYourSpaceContainerInterface> = () => {
  return (
    <LikedYourSpaceComponent />
  )
}

export default LikedYourSpaceContainer;
